import React from 'react';
import List from '../../../../../../../components/list/list';

const PlanosTussList = ({ handleChangeMode,planosTuss }) => {
 
  if (planosTuss.length === 0) {
    return <span>Nenhum procedimento encontrado</span>;
  }

  return (
    <List
      columns={[
        {
          title: 'Descrição',
          value: (item) => item.servicoExibicao?.descricao,
        },
      ]}
      items={planosTuss || []}
      loading={false}
      error={false}
      last={true}
      onLoadMore={() => null}
      onClickItem={(e) => handleChangeMode('update', e)}
    />
  );
};

export default PlanosTussList;
